export const ACTUALIZAR_LIST_CONTROL = "ACTUALIZAR_LIST_CONTROL";
export const MODIFICAR_CONTROL = "MODIFICAR_CONTROL";
export const AGREGAR_CONTROL = "AGREGAR_CONTROL";  
export const ELIMINAR_CONTROL = "ELIMINAR_CONTROL";